import {langEn, langRu} from 'yougile-lang'

import {DataObjectId} from 'yougile-model'
import {ContextObject} from '../context-object'

/**
 * @description
 * Getting and changing application interface texts.
 * @descriptionRu
 * Получает и изменяет тексты интерфейса приложения.
 */
export class Texts extends ContextObject {
  public static override registered: Map<DataObjectId, Map<string, Texts>> =
    new Map()

  /**
   * @code
   * Texts.ru
   * @example
   * Texts.ru.projects = 'Отделы';
   * @description
   * Allows get and change language strings.
   * @descriptionRu
   * Позволяет получать и изменять строки в системе.
   */
  public get ru(): typeof langRu {
    return langRu
  }

  /**
   * @code
   * Texts.en
   * @example
   * Texts.en.projects = 'Departments';
   * @description
   * Allows get and change language strings.
   * @descriptionRu
   * Позволяет получать и изменять строки в системе.
   */
  public get en(): typeof langEn {
    return langEn
  }
}
